 <printheaderview [hasimage]="0"></printheaderview>
<div class="col-md-12">
  <div class="card">
    <div class="card-header">
      <label class="label-size-2 font-color-secondary text-align-center">List Of Services</label>

    </div>
    <div class="card-body">
      <div class="table-component">
        <div class="table-responsive overflow-x-hidden">


          <table class="table table-striped margin-left-zero pgbreak">

            <thead class="">
              <tr>

                <th class="td-width-3px">Code</th>

                <th class="">Name</th>


                <th class="">Base Price</th>
              </tr>
            </thead>
            <tbody class="table-body pgbreak">
              <tr *ngFor="let l of invoiceDetails" class="pgbreak">
                <td><a>{{l.Code}}</a></td>
                <td><a>{{l.ServiceName}}</a></td>

                <td class="text-align-center">

                  {{l.BasePrice}}

                </td>





              </tr>

            </tbody>

          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<printfooterview></printfooterview>



